import React, { PureComponent } from 'react';

import CalendarBase from './calendar-base/CalendarBase';
import * as CalendarState from '../../state/reducer/calendar/calendar';
import { getState } from '../../state/store';

import Console from '../../lib/debug';

export default class ProgramCalendarView extends PureComponent {
    constructor(props) {
        super(props);
        this.loadCalendarData(props);
    }

    componentWillUpdate(nextProps) {
        this.loadCalendarData(nextProps);
    }

    loadCalendarData(props) {
        const programId = parseInt(props.match.params.programId, 10);
        const infoTree = getState().calendar.infoTree;
        const programMatch =
            infoTree.programId === programId || infoTree.team.id === programId;

        if (programMatch) return;

        CalendarState.loadProgram(programId);
    }

    render() {
        Console.render('ProgramCalendarView');
        return <CalendarBase />;
    }
}
